import { render, staticRenderFns } from "./introducePageFive.vue?vue&type=template&id=5b570ea4&scoped=true"
import script from "./introducePageFive.vue?vue&type=script&lang=js"
export * from "./introducePageFive.vue?vue&type=script&lang=js"
import style0 from "./introducePageFive.vue?vue&type=style&index=0&id=5b570ea4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b570ea4",
  null
  
)

export default component.exports